module.exports = __webpack_public_path__ + "static/img/donate-box-bg.4e9edba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/donate-box-bg.png
// module id = FoBI
// module chunks = 1